import React, { useState, useEffect } from "react";
import MarketStats from "../components/market-stats";
import Table from "../components/table";
import IsFetchingAction from "../actions/isFetchingAction";
import fetchData from "../actions/fetchData";

const Home = () => {
  const [data, setData] = useState({
    stats: {
      totalCryptos: "",
      marketCap: "",
      volume: "",
    },
    coins: [],
  });
  const [IsFetching, setIsFetching] = useState(false);

  useEffect(
    () => IsFetchingAction({ setIsFetching, IsFetching }),
    [IsFetching]
  );

  useEffect(() => fetchData({ setData }), [IsFetching]);

  return (
    <div className="App">
      <MarketStats
        totalMarkets={data.stats.totalCoins}
        totalMarketCap={data.stats.marketCap}
        total24hVolume={data.stats.volume}
      />
      <div className="table-container">
        <Table coins={data.coins} />
      </div>
    </div>
  );
};

export default Home;
